export default __webpack_public_path__ + "static/media/google-analytic.32f79454.svg";